import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { MLNameDetailsComponent } from 'ml-components-common-react';

import styles from './MLPartialDriverDetailsComponent.module.scss';
import metadata from './MLPartialDriverDetailsComponent.metadata.json5';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
const MLPartialDriverDetailsComponent = (props) => {
    const {
        driver, 
        checkUniqueSelf,
        checkUniqueSpouse,
        onValidate,
        showValidationErrors,
        isExcluded,
        submissionVM,
        viewModelService
    } = props;

    const { refreshData } = useDataRefresh();
    const isAMP = appConfig.portalCode === 'AMP';
    const isGPA = appConfig.portalCode === 'GPA';
    const translator = useTranslator();
    const relationTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('InsuredRelationType_ML');

    const getTodaysDate = useCallback(() => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate());
    });
    const getRelationshipClassName = useCallback(() => {
        let className = isAMP ? classNames('remove-form-group-spacing', 'col-md-6') : classNames('remove-form-group-spacing', 'col-md-4');
        if (!checkUniqueSelf() || !checkUniqueSpouse()) {
            className = classNames('vertical-spacing-10', className);
        }
        return className;
    }, [checkUniqueSelf, checkUniqueSpouse, isAMP]);

    const {
        getFilteredGender
    } = MLDriverVehicleUtil(viewModelService);

    const getRelationshipTypeOptions = () => {
        const codes = relationTypeList.codes;
        return codes.map((option) => {
            return {
                code: option.code,
                name: translator({
                    id: option.name,
                    defaultMessage: option.name
                })
            };
        });
    };

    const updateDriverVM = () => {
        refreshData();
    };

    const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
    const overrideProps = {
        nameDetailsComponent: {
            layout: isAMP ? 'ML-Split' : 'ML-Name-Default',
            showLabels: isAMP,
            personVM: driver.person,
            onValidate,
            showValidationErrors,
            onModelChange: updateDriverVM
        },
        relationshipControl: {
            className: getRelationshipClassName()
        },
        relationship : {
            availableValues: getRelationshipTypeOptions()
        },
        uniqueSelfError: {
            visible: !checkUniqueSelf()
        },
        uniqueSpouseError: {
            visible: !checkUniqueSpouse()
        },
        dobControl: {
            className: isAMP ? classNames('remove-form-group-spacing', 'col-md-6') : classNames('remove-form-group-spacing', 'col-md-4')
        },
        dobTooltipContainer: {
            visible: !isGPA,
            className: isAMP ? 'col-md-6' : 'col-md-8'
        },
        maritalStatusRow: {
            visible: isExcluded
        },
        maritialStatusControl: {
            className: isAMP ? classNames('remove-form-group-spacing', 'col-md-6') : classNames('remove-form-group-spacing', 'col-md-4')
        },
        genderRow: {
            path: "gender",
            availableValues: getFilteredGender(nbGenderState)
        },
        dob:{
            maxDate: getTodaysDate(),                 
        }     
    };

    const resolvers = {
        resolveComponentMap: {
            mlnamedetailscomponent: MLNameDetailsComponent
        },
        resolveClassNameMap: styles,
    };
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={driver}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onModelChange={updateDriverVM}
            onValidationChange={onValidate}
            showErrors={showValidationErrors}
        />
    );
};

MLPartialDriverDetailsComponent.propTypes = {
    driver: PropTypes.object.isRequired,
    checkUniqueSelf: PropTypes.func.isRequired,
    checkUniqueSpouse: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool,
    isExcluded: PropTypes.bool
}

MLPartialDriverDetailsComponent.defaultProps = {
    showValidationErrors: false,
    isExcluded: false
}

export default MLPartialDriverDetailsComponent;
